import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import userLabel from './modules/userLabel';

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    userLabel
  },
  state: {
    resultDetails: '',  // 换绑字段
    userLabelResult: '',  // 风险标签字段
    antibeeResult: '',  // 反养蜂字段
    h5OcrValidateResult: '',  // 人脸核身字段
    h5OcrValidateChangeRes: '',  // 人脸核身换绑字段
    h5OcrValidateResult_userLabel: '',   // 用户风险标签 215 | 216 结果码调用人脸核身字段
    personInfo: {
      name: '',
      cardNo: ''
    },
  },
  getters: {
  },
  mutations: {
    set_resultDetails: (state, data) => {
      state.resultDetails = data;
    },
    set_userLabelResult: (state, data) => {
      state.userLabelResult = data;
    },
    set_antibeeResult: (state, data) => {
      state.antibeeResult = data;
    },
    set_h5OcrValidateResult: (state, data) => {
      state.h5OcrValidateResult = data;
    },
    set_h5OcrValidateChangeRes: (state, data) => {
      state.h5OcrValidateChangeRes = data;
    },
    set_h5OcrValidateResult_userLabel: (state, data) => {
      state.h5OcrValidateResult_userLabel = data;
    },
    set_personInfo: (state, data) => {
      state.personInfo = data;
    },
  },
  actions: {
  },
})
